// extracted by mini-css-extract-plugin
module.exports = {"tagListLetterHeader":"TagListItemsHeader_tagListLetterHeader__2CruJ"};